export default "__VITE_ASSET__BtlQSBEQ__"